import React, { useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import CustomHelpButton from "./NewHelpButton"
import { LINKTREE_KOL } from "../Utils/HelpButtonHelperFunction"
import { TIP_DIRECTION } from "../Enum/HELP_BTN_SYSYEM"

interface PropsType {
  userName: string
  disabled?: boolean
}

const ProfileLinksShareBox: React.FC<PropsType> = ({ userName, disabled }) => {
  const [copy, setCopy] = useState<boolean>(false)

  const copyClipboard = async () => {
    if (navigator.clipboard) {
      let lang = localStorage.getItem("i18n-lang") === "en" ? "en" : "hk"
      let text = "https://look4kol.com/" + lang + "/link/" + userName
      await navigator.clipboard.writeText(text)
    }
  }

  return (
    <div className="my-2 w-full  inline-block ">
      <div className="block text-sm text-gray-500 mb-2">
        <Trans>ProfileLinksPage.share-now</Trans>

        <CustomHelpButton
          helpDoc={LINKTREE_KOL}
          tipDirection={TIP_DIRECTION.RIGHT}
        />
      </div>
      <div className="block md:grid text-left ">
        <div>
          <button
            onClick={() => {
              setCopy(true)
              copyClipboard()
            }}
            disabled={disabled}
            className="btn w-full mt-2 h-12 rounded-xl normal-case ">
            {copy ? (
              <Trans>ProfileLinksPage.copied</Trans>
            ) : (
              <Trans>ProfileLinksPage.copy</Trans>
            )}
          </button>
        </div>
      </div>
    </div>
  )
}
export default ProfileLinksShareBox
